module.exports = "/assets/data/700a953ca1b310c75e491973867d01ff-EC2A.data.json";